import React from 'react'
import { CellProps } from 'react-table'

import { LinkToOrder } from './LinkToOrder'
import { TableDataCustomerOrder, TableDataRewardsOrder } from './types'

export interface OrderCellProps extends CellProps<TableDataCustomerOrder | TableDataRewardsOrder> {
  urlFragment: string
}

export const OrderCell: React.VFC<OrderCellProps> = ({ row, urlFragment, value }) => (
  <LinkToOrder orderId={row.original.orderId} urlFragment={urlFragment}>
    {value}
  </LinkToOrder>
)
